<template>
  <div id="eoc-medications-v1-5srlcf" class="fb-eoc-medications-v1">
    <div id="eoc-medications-v1-6zxqxe" v-if="showType == 'form-builder'" :style="properties.style">
      <b-form-group id="eoc-medications-v1-kk2jag"
        :description="computedPropertiesForm.description"
        :label="computedPropertiesForm.label"
        :style="properties.style"
      >
        <b-table id="eoc-medications-v1-ag9b64"
          responsive
          :items="tableProperties.items"
          :fields="tableProperties.columns"
        ></b-table>
      </b-form-group>
    </div>
    <div id="eoc-medications-v1-mckjx3" v-else-if="showType == 'properties'">
      <eoc-medications-v1-properties id="eoc-medications-v1-0fqr6i" :formId="formId" />
    </div>
    <div id="eoc-medications-v1-uukklx"
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
        (showType == 'e-form' && properties.eFormEditable)
      "
      :style="properties.style"
      class="medication-table-container"
      v-show="!computedHidden"
    >
      <b-form-group id="eoc-medications-v1-b7cbw9"
        :description="computedPropertiesForm.description"
        :style="properties.style"
      >
        <template v-slot:label="">
          <div id="eoc-medications-v1-8dwdty" class="d-flex align-items-center mb-3">
            <span id="eoc-medications-v1-t35ses" style="font-size: 16px" class="mr-3">
              {{ computedPropertiesForm.label }}
            </span>
          </div>
        </template>
        <b-table id="eoc-medications-v1-93kkyn"
          striped
          responsive
          hover
          :items="tableProperties.items"
          :fields="tableProperties.columns"
        >
          <template #cell(signature)="row">
            <div id="eoc-medications-v1-mm68xq" v-html="row.item.signature"></div>
          </template>
        </b-table>
      </b-form-group>
    </div>
    <div id="eoc-medications-v1-9cavib"
      v-if="showType == 'form-viewer'"
      :style="properties.style"
      class="medication-table-container"
    >
      <b-table id="eoc-medications-v1-toroad"
        responsive
        :items="tableProperties.items"
        :fields="tableProperties.columns"
      ></b-table>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import EocMedicationsV1Properties from "./EocMedicationsV1Properties.vue";
import marsServer from "../../../../server/marsRecord";
import { formatDate } from "../../../../helpers/date";
import { formatUser } from "../../../../helpers/user";

export default {
  name: "EocMedicationsV1",
  components: { EocMedicationsV1Properties },
  props: [
    "showType",
    "properties",
    "form",
    "id",
    "formId",
    "page",
    "componentsIdSuffix"
  ],
  data() {
    return {
      computedProperties: ["description", "label", "hidden"],
      computedConditions: {},
      medicationRecords: []
    };
  },
  async mounted() {
    if (
      this.showType != "form-builder" &&
      (this.showType == "form-submitter" || this.showType == "e-form")
    ) {
      const medications = await marsServer.FindAllFromEoc(
        this.client.episodeOfCare.id
      );
      this.medicationRecords = medications.records.map((medication) => ({
        ...medication,
        dateTime: formatDate(medication.dateTime),
        type: medication.type.toUpperCase(),
        medicationLabel: `${medication.medication?.name}, ${medication.dosageAmount} ${medication.unitOfMeasurement?.name} by ${medication.medicationRoute?.name}`,
        givenBy: medication.givenBy ? formatUser(medication.givenBy) : "",
        signedBy: medication.signedBy ? formatUser(medication.signedBy) : ""
      }));
    }
    const preCode = `patient.episodeOfCare.medications = ${JSON.stringify(
      this.medicationRecords
    )};`;
    if (
      this.showType == "form-submitter" &&
      this.properties.value.includes("{{")
    ) {
      this.medicationRecords = this.superComputeFormSubmitterValue({
        elementId: this.id,
        property: "value",
        value: this.properties.value,
        defaultValue: "",
        form: this.form,
        preCode: preCode,
        componentPage: this.page
      });
    }

    this.computeConditions();
    this.$emit("mount-done");
  },
  methods: {
    ...mapActions("formSubmitter", [
      "setFormSubmitterComponentValue",
      "computeFormSubmitterValue"
    ]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties("hidden");

      if (hidden === true) return "";

      return `
      <fieldset aria-describedby="" class="form-group is-table" id="__BVID__48">
        <legend style="font-size:16px;" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" id="__BVID__48__BV_label_">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div>
            <div>
              <table role="table" aria-busy="false" aria-colcount="3" class="table b-table custom-fb-table mt-2 table-striped table-responsive table-hover" id="__BVID__50">
                <thead role="rowgroup" class="">
                  <tr role="row" class="">
                    <th role="columnheader" scope="col" aria-colindex="1" class="">
                      <div>Date & Time</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="2" class="">
                      <div>Status</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="3">
                      <div>Type</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="4">
                      <div>Medication</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="5">
                      <div>Given By</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="5">
                      <div>Notes</div>
                    </th>
                     <th role="columnheader" scope="col" aria-colindex="5">
                      <div>Signed By</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="5">
                      <div>Signature</div>
                    </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                ${(this.tableProperties.items || [])
                  .map(
                    (item) => `
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="" style="min-width: 130px;">${
                      item.dateTime
                    }</td>
                    <td aria-colindex="2" role="cell" class="" style="min-width: 130px;">${
                      item.status
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 130px;">${
                      item.type
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 130px;">${
                      item.medicationLabel
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 130px;">${
                      item.givenBy
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 130px; max-width: 200px;">${
                      item.notes ? item.notes : ""
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 100px;">${
                      item.signedBy
                    }</td>
                    <td aria-colindex="3" role="cell" style="min-width: 100px;">${
                      item.signature
                    }</td>
                  </tr>
                `
                  )
                  .join("")}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      client: (state) => state.form.client,
      currentPage: (state) => state.form.currentPage
    }),
    computedPropertiesForm() {
      return (
        this.$store.state.formSubmitter.form.computedProperties[this.id] ??
        this.properties
      );
    },
    tableProperties() {
      let items = this.medicationRecords.map((item) => ({
        ...item,
        signature: item.signature
          ? `<img style="width: 80px;" src="${item.signature}" />`
          : ""
      }));
      return {
        ...this.properties,
        items: items,
        columns: [
          {
            key: "dateTime",
            label: "Date & Time"
          },
          {
            key: "status",
            label: "Status"
          },
          {
            key: "type",
            label: "Type"
          },
          {
            key: "medicationLabel",
            label: "Medication"
          },
          {
            key: "givenBy",
            label: "Given By"
          },
          {
            key: "notes",
            label: "Notes"
          },
          {
            key: "signedBy",
            label: "Signed By"
          },
          {
            key: "signature",
            label: "Signature",
            html: true
          }
        ]
      };
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden;

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>

<style scoped>
.medication-table-container >>> td {
  min-width: 130px;
}
</style>
